import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { sendTemplateEmail } from "@/lib/email-templates/send-email";

const ContactSchema = z.object({
  name: z.string().trim().min(1).max(100),
  email: z.string().trim().email().max(255),
  subject: z.string().trim().max(200).optional().default(""),
  message: z.string().trim().min(10).max(4000),
  // Honeypot: bots fill this; real users leave it blank.
  website: z.string().max(0).optional().default(""),
});

export const submitContactMessage = createServerFn({ method: "POST" })
  .inputValidator((input: unknown) => ContactSchema.parse(input))
  .handler(async ({ data }) => {
    if (data.website && data.website.length > 0) {
      // Silently accept: pretend success, drop message.
      return { ok: true as const };
    }

    const idBase = `${data.email}-${Date.now()}`;

    try {
      // Notify the editor.
      await sendTemplateEmail("contact-editor-notification", "hello@acadly.in", {
        templateData: {
          name: data.name,
          email: data.email,
          subject: data.subject || "",
          message: data.message,
        },
        idempotencyKey: `contact-editor-${idBase}`,
        replyTo: data.email,
      });
    } catch (err) {
      console.error("[contact] editor notification failed", err);
      throw new Error(
        "Message could not be delivered right now. Please email hello@acadly.in directly.",
      );
    }

    // Send the sender a confirmation. Failures here are non-fatal.
    try {
      await sendTemplateEmail("contact-confirmation", data.email, {
        templateData: {
          name: data.name,
          subject: data.subject || "",
          message: data.message,
        },
        idempotencyKey: `contact-confirm-${idBase}`,
      });
    } catch (err) {
      console.error("[contact] sender confirmation failed", err);
    }

    return { ok: true as const };
  });